import { render, staticRenderFns } from "./ServiceProviderFreelancerProfile.vue?vue&type=template&id=e13a0508"
import script from "./ServiceProviderFreelancerProfile.vue?vue&type=script&lang=js"
export * from "./ServiceProviderFreelancerProfile.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderFreelancerProfile.vue?vue&type=style&index=0&id=e13a0508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports